import { useEffect, useRef } from "react";

export const TIMEZONE = "Asia/Singapore";
export const MINIMUM_SCHEDULING_NOTICE_KEYWORD =
  "Booking Minimum Scheduling Notice";
export const ALLOW_ONLINE_BOOKING_KEYWORD = "Allow Online Booking";
export const DATE_RANGE_KEYWORD = "Booking Date Range";
export const DATE_TIME_FORMAT = "DD/MM/yyyy HH:mm";
export const DATE_FORMAT = "DD/MM/yyyy";
export const TIME_FORMAT = "HH:mm";

export const formatTime = (date: Date) =>
  `${date.getHours().toString().padStart(2, "0")}:${date
    .getMinutes()
    .toString()
    .padStart(2, "0")}`;

export const usePrevious: <T>(value: T) => T | undefined = (value) => {
  const ref = useRef<typeof value>();
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
};

export function findLastIndex<T>(
  array: Array<T>,
  predicate: (value: T, index: number, obj: T[]) => boolean
): number {
  let l = array.length;
  while (l--) {
    if (predicate(array[l], l, array)) return l;
  }
  return -1;
}
